import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    PaymentTransactions_Create,
    PaymentTransactions_Delete,
    PaymentTransactions_ReadAll,
    PaymentTransactions_ReadById,
    PaymentTransactions_ReadByUserId,
    PaymentTransactions_ReadByBusinessId,
    PaymentTransactions_ReadByModuleEntityId,
    PaymentTransactions_ReadByPRRN,
    PaymentTransactions_PaymentUpdateStatus,
    PaymentTransactions_Update
} from "src/app/GlobalVariable";
import { PaymentTransactionsCreateRequestDTO, PaymentTransactionsResponseDTO, PaymentTransactionsReadAllResponseDTO, PaymentTransactionsDeleteRequestDTO, PaymentTransactionsReadByIdRequestDTO, PaymentTransactionsReadByUserIdRequestDTO, PaymentTransactionsReadByBusinessIdRequestDTO, PaymentTransactionsReadByModuleEntityIdRequestDTO, PaymentTransactionsReadByPRRNRequestDTO, PaymentTransactionsUpdateStatusRequestDTO, PaymentTransactionsUpdateRequestDTO } from "./payment-transactions.interface";

@Injectable({
    providedIn: 'root'
})
export class PaymentTransactionsService {

    private http = inject(HttpClient);

    PaymentTransactions_Create(data: PaymentTransactionsCreateRequestDTO): Observable<PaymentTransactionsResponseDTO> {
        return this.http.post<PaymentTransactionsResponseDTO>(PaymentTransactions_Create, data);
    }

    PaymentTransactions_Update(data: PaymentTransactionsUpdateRequestDTO): Observable<PaymentTransactionsResponseDTO> {
        return this.http.post<PaymentTransactionsResponseDTO>(PaymentTransactions_Update, data);
    }

    PaymentTransactions_ReadAll(): Observable<PaymentTransactionsReadAllResponseDTO> {
        return this.http.get<PaymentTransactionsReadAllResponseDTO>(PaymentTransactions_ReadAll);
    }

    PaymentTransactions_Delete(data: PaymentTransactionsDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(PaymentTransactions_Delete, data);
    }

    PaymentTransactions_ReadById(data: PaymentTransactionsReadByIdRequestDTO): Observable<PaymentTransactionsResponseDTO> {
        return this.http.post<PaymentTransactionsResponseDTO>(PaymentTransactions_ReadById, data);
    }

    PaymentTransactions_ReadByUserId(data: PaymentTransactionsReadByUserIdRequestDTO): Observable<PaymentTransactionsReadAllResponseDTO> {
        return this.http.post<PaymentTransactionsReadAllResponseDTO>(PaymentTransactions_ReadByUserId, data);
    }

    PaymentTransactions_ReadByBusinessId(data: PaymentTransactionsReadByBusinessIdRequestDTO): Observable<PaymentTransactionsReadAllResponseDTO> {
        return this.http.post<PaymentTransactionsReadAllResponseDTO>(PaymentTransactions_ReadByBusinessId, data);
    }

    PaymentTransactions_ReadByModuleEntityId(data: PaymentTransactionsReadByModuleEntityIdRequestDTO): Observable<PaymentTransactionsReadAllResponseDTO> {
        return this.http.post<PaymentTransactionsReadAllResponseDTO>(PaymentTransactions_ReadByModuleEntityId, data);
    }

    PaymentTransactions_ReadByPRRN(data: PaymentTransactionsReadByPRRNRequestDTO): Observable<PaymentTransactionsResponseDTO> {
        return this.http.post<PaymentTransactionsResponseDTO>(PaymentTransactions_ReadByPRRN, data);
    }
    PaymentTransactions_PaymentUpdateStatus(data: PaymentTransactionsUpdateStatusRequestDTO): Observable<PaymentTransactionsResponseDTO> {
        return this.http.post<PaymentTransactionsResponseDTO>(PaymentTransactions_PaymentUpdateStatus, data);
    }
}
